import documentService from '@/modules/document/documentService'
import { errorCodes } from '@/modules/base/util/constants'
import { isObject } from 'lodash'

// actions
const SHOW_LOADER_DOCUMENTS_SETUP = 'SHOW_LOADER_DOCUMENTS_SETUP'
const HIDE_LOADER_DOCUMENTS_SETUP = 'HIDE_LOADER_DOCUMENTS_SETUP'
const SET_DOCUMENT_ACCOUNT_INFOS = 'SET_DOCUMENT_ACCOUNT_INFOS'
const UPDATE_DOCUMENT_ACTIVE_STEP_KEY = 'UPDATE_DOCUMENT_ACTIVE_STEP_KEY'
const UPDATE_DOCUMENT_ACCOUNT_API_KEY = 'UPDATE_DOCUMENT_ACCOUNT_API_KEY'
const ERROR_CREATING_DOCUMENT_ACCOUNT = 'ERROR_CREATING_DOCUMENT_ACCOUNT'
const ERROR_FETCHING_DOCUMENT_ACCOUNT = 'ERROR_FETCHING_DOCUMENT_ACCOUNT'
const ERROR_UPDATE_DOCUMENT_ACCOUNT_API_KEY = 'ERROR_UPDATE_DOCUMENT_ACCOUNT_API_KEY'

// reducer
const initialState = {
  isLoading: false,
  error: null,
  activeStepKey: null,
  data: {
    active: null,
    accountPrimUid: null,
    userPrimUid: null,
    isExpired: null,
    hasApiKey: null,
    begin: null,
    end: null,
    cancelDate: null,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER_DOCUMENTS_SETUP:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_LOADER_DOCUMENTS_SETUP:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SET_DOCUMENT_ACCOUNT_INFOS:
      return Object.assign({}, state, {
        data: { ...state.data, ...action.data },
        error: null,
      })

    case UPDATE_DOCUMENT_ACCOUNT_API_KEY:
      return Object.assign({}, state, {
        data: { ...state.data, ...action.data },
        error: null,
      })

    case UPDATE_DOCUMENT_ACTIVE_STEP_KEY:
      return Object.assign({}, state, {
        ...action.data,
        error: null,
      })

    case ERROR_FETCHING_DOCUMENT_ACCOUNT:
      if (action.error === 'Account not exists') {
        return Object.assign({}, state, {
          isLoading: false,
          error: null,
        })
      }
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      })

    case ERROR_CREATING_DOCUMENT_ACCOUNT:
    case ERROR_UPDATE_DOCUMENT_ACCOUNT_API_KEY:
      const { error } = action
      return Object.assign({}, state, {
        isLoading: false,
        error,
      })

    default:
      return state
  }
}

// action creators
export const showLoader = () => {
  return {
    type: SHOW_LOADER_DOCUMENTS_SETUP,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_LOADER_DOCUMENTS_SETUP,
  }
}

export const errorCreatingDocumentAccount = (error) => {
  return {
    type: ERROR_CREATING_DOCUMENT_ACCOUNT,
    error,
  }
}

export const errorFetchingDocumentAccount = (error) => {
  return {
    type: ERROR_FETCHING_DOCUMENT_ACCOUNT,
    error,
  }
}

export const setDocumentAccountInfos = (data) => {
  return {
    type: SET_DOCUMENT_ACCOUNT_INFOS,
    data,
  }
}

export const updateDocumentAccountApiKey = (data) => {
  return {
    type: UPDATE_DOCUMENT_ACCOUNT_API_KEY,
    data,
  }
}

export const errorUpdateDocumentAccountApiKey = (error) => {
  return {
    type: ERROR_UPDATE_DOCUMENT_ACCOUNT_API_KEY,
    error,
  }
}

export const updateActiveStepKey = (stepKey) => {
  return {
    type: UPDATE_DOCUMENT_ACTIVE_STEP_KEY,
    data: { activeStepKey: stepKey },
  }
}

export const setActiveStepKey = (stepKey) => {
  return (dispatch) => dispatch(updateActiveStepKey(stepKey))
}

export const fetchAccount = () => {
  return (dispatch) => {
    dispatch(showLoader())
    documentService.fetchAccount().then(data => {
      dispatch(setDocumentAccountInfos(data))
      dispatch(hideLoader())
    }).catch((error) => dispatch(errorFetchingDocumentAccount(isObject(error) ? error.body.message : error)))
  }
}

export const createTestAccount = () => {
  return (dispatch) => {
    dispatch(showLoader())
    documentService.createAccount().then(data => {
      dispatch(setDocumentAccountInfos(data))
      if (data.hasApiKey) {
        dispatch(updateActiveStepKey('success'))
      } else {
        dispatch(updateActiveStepKey('apiKey'))
      }
      dispatch(hideLoader())
    }).catch((error) => {
      const errorMeta = error?.body?.meta
      if (errorMeta.email && errorMeta.email[0].code === errorCodes.EXISTS) {
        dispatch(updateActiveStepKey('apiKey'))
        dispatch(hideLoader())
      } else if ((errorMeta.code && errorMeta.code[0].code === 102)) {
        dispatch(updateActiveStepKey('userData'))
        dispatch(hideLoader())
      } else {
        const errorMessage = isObject(error) ? error.body.message : error
        dispatch(errorCreatingDocumentAccount(errorMessage))
      }
    })
  }
}
